'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
Object.defineProperty(exports, 'JestFakeTimers', {
  enumerable: true,
  get: function get() {
    return _jestFakeTimers.default;
  }
});

var _jestFakeTimers = _interopRequireDefault(require('./jestFakeTimers'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}
